export default "__VITE_ASSET__BVSW4WtO__"